import { GET_EVENTS, CLEAN_EVENTS } from '../types';
import network from '../../services/network';
import { callApi } from './utils';

export const getEvents = params => {
  const action = () => network.getEvents(params);
  return callApi(action, GET_EVENTS);
};

export const cleanEvents = () => {
  return {
    type: CLEAN_EVENTS,
  };
};
